import { DatePipe } from "@angular/common";
import { Component, Inject, OnInit } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup } from "@angular/forms";
// import { UntypedFormControl, UntypedFormGroup } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { SharedService } from "@shared/services/shared.service";
import { IEnclosedAreaEditHistory } from "app/models/reports/reports";
import { ComplaintService } from "app/services/complaint/complaint.service";

@Component({
  selector: 'reportEnclosedArea',
  styleUrls: ['./reportEnclosedArea.component.scss'],
  templateUrl: './reportEnclosedArea.component.html'
})

export class ReportEnclosedAreaComponent implements OnInit {

  // currentInspection: IBusinessExemptInspectionsViewModel = {} as IBusinessExemptInspectionsViewModel;
  businessId: number = 0;
  saved: boolean = false;
  showSave: boolean = false;
  reviewed: boolean = false;
  underReview: boolean = false;
  followupInspection: boolean = false;
  siteVisitConducted: boolean = false;

  enclosedArea: IEnclosedAreaEditHistory = {
    id: '0',
    businessId: 0,
    complaintId: 0,
    enclosedArea: false,
    enclosedAreaReviewed: false,
    enclosedAreaAdmin: false,
    enclosedAreaDetermination: '0',
    enclosedAreaDeterminationComments: '0',
    timeStamp: '0',
    loggedUser: '0',
    visitDate: '0',
    visitComments: '0',
    comments: '0',
    editHistory: [],
    files: []
  };

  form = new UntypedFormGroup({
    visitDate: new UntypedFormControl(''),
    comments: new UntypedFormControl(''),
  });

  constructor(
    private sharedService: SharedService,
    private complaintService: ComplaintService,
    private datePipe: DatePipe,
    private dialogRef: MatDialogRef<ReportEnclosedAreaComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if (this.data.enclosedArea != null && this.data.enclosedArea != undefined) {
      this.enclosedArea = this.data.enclosedArea;
      if (!this.enclosedArea.enclosedAreaReviewed) {
        this.form.controls['visitDate'].setValue(new Date(this.enclosedArea.visitDate));
        this.form.controls['comments'].setValue(this.enclosedArea.comments);
        this.underReview = true;
      }
      else {
        this.underReview = false;
      }
      this.showSave = true;
    }
    this.businessId = this.data.businessId;
  }

  ngOnInit(): void {
    this.saved = false;
  }

  save() {
    if (this.underReview) {
      this.sharedService.openNotice("This enclosed area is under review. Please wait for the enclosed area determination.");
    }
    else {

      this.sharedService.openConfirm("Are you sure you want to report an enclosed area?" +
        "\n\nSome site features will be locked until OHA makes an enclosed area determination."
      );
      this.sharedService.confirmed().subscribe(
        confirmed => {
          if (confirmed) {
            this.enclosedArea.businessId = this.businessId;
            this.enclosedArea.comments = this.form.controls['comments'].value;
            this.enclosedArea.visitDate = this.datePipe.
                transform(this.form.controls['visitDate'].value, 'MM/dd/yyyy');
            this.complaintService.reportEnclosedArea(this.enclosedArea).subscribe({
              next: response => {
                this.sharedService.toastr.success("Saved");
                this.saved = true;
                this.return();
              },
              error: e => {
                this.sharedService.toastr.error("Could not save Area Info");
              },
            });
          }
        }
      );
    }
  }

  dateChanged(date: string) {
    this.enclosedArea.visitDate = date;
    this.showSave = date != null ? true : false;
  }

  return(): void {
    let returnData = this.saved ? 'saved' : 'cancel';
    this.dialogRef.close(returnData);
  }
}